// extracted by mini-css-extract-plugin
export default {"wrapper":"ChoiceComponent_wrapper__a2RgS","point":"ChoiceComponent_point__ys-S4"};